var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide:instagram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0835 2.83325H9.91683C6.00481 2.83325 2.8335 6.00457 2.8335 9.91659V24.0833C2.8335 27.9953 6.00481 31.1666 9.91683 31.1666H24.0835C27.9955 31.1666 31.1668 27.9953 31.1668 24.0833V9.91659C31.1668 6.00457 27.9955 2.83325 24.0835 2.83325Z",
    stroke: "#EDEDED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.7921 9.20825H24.8062M22.6671 16.1074C22.8419 17.2864 22.6405 18.4906 22.0916 19.5485C21.5426 20.6065 20.674 21.4644 19.6094 22.0003C18.5447 22.5362 17.3382 22.7227 16.1614 22.5333C14.9847 22.344 13.8976 21.7884 13.0548 20.9456C12.2119 20.1028 11.6564 19.0157 11.467 17.8389C11.2776 16.6621 11.4642 15.4556 12 14.3909C12.5359 13.3263 13.3938 12.4577 14.4518 11.9088C15.5098 11.3598 16.7139 11.1584 17.8929 11.3333C19.0955 11.5116 20.2089 12.072 21.0686 12.9317C21.9283 13.7914 22.4887 14.9048 22.6671 16.1074Z",
    stroke: "#EDEDED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.f91fe360ecd297a4bf28a69361ac13a7.svg";
export { ForwardRef as ReactComponent };